<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-short-task`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 2a1 1 0 011 1v3h6a2 2 0 012 2v36a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2h6V3a1 1 0 011-1h18zm-19 8h-4v32h28V10h-4v3a1 1 0 01-1 1H15a1 1 0 01-1-1v-3zm19 20a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zM30 6H18v4h12V6z"/></svg>
</template>
<script>

export default {
  name: 'IconShortTask',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
